module.exports = __webpack_public_path__ + "static/media/eg-cloud.f32ba206.png";